module.exports = __webpack_public_path__ + "static/media/new-arrival-icon.4b103a02.svg";